import { Injectable } from '@angular/core';
import { ConfigurationService } from '../conf/configuration.service';
import { environment } from '../../../../environments/environment';

@Injectable()
export class PlatformService {
	public constructor(private conf: ConfigurationService) {}

	public get deployUrl(): string {
		return environment.deployUrl || '';
	}
}
